import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, map, Observable, shareReplay } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Region } from '../models/region';

@Injectable({
  providedIn: 'root',
})
export class RegionService {
  API_URL = `${environment.apiUrl}/regions`;
  CACHE_SIZE = 1;
  private cache$!: Observable<Array<Region>>;
  isRegionLoading$ = new BehaviorSubject<boolean>(false);

  constructor(private http: HttpClient) {}

  get regions() {
    if (!this.cache$) {
      this.cache$ = this.requestRegions().pipe(shareReplay(this.CACHE_SIZE));
      this.isRegionLoading$.next(true);
    }
    this.isRegionLoading$.next(false);
    return this.cache$;
  }

  private requestRegions() {
    return this.http.get<Region[]>(this.API_URL);
  }

  getRegions(): Observable<Region[]> {
    return this.http.get<Region[]>(this.API_URL).pipe(
      map(regions => regions.sort((a, b) => {
          const dateA = a.modifiedDate ? new Date(a.modifiedDate).getTime() : 0;
          const dateB = b.modifiedDate ? new Date(b.modifiedDate).getTime() : 0;
          if (dateB !== dateA) {
            return dateB - dateA;
          }
          return (b.id ?? 0) - (a.id ?? 0);
        }))
      );
  }

  addRegion(region: Region): Observable<Region> {
    return this.http.post<Region>(this.API_URL, region);
  }

  updateRegion(region: Region): Observable<Region> {
    return this.http.put<Region>(`${this.API_URL}/${region.id}`, region);
  }

  deleteRegion(id: number): Observable<void> {
    return this.http.delete<void>(`${this.API_URL}/${id}`);
  }
}
